import React from "react";
import { Link } from "react-router-dom";
import { LOGO } from "../lib/api";

const COL = (title, links) => (
  <div>
    <div className="overline mb-5 text-ivory/50">{title}</div>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}><Link to={l.to} className="text-ivory/75 hover:text-ivory text-sm transition-colors">{l.label}</Link></li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-forest text-ivory relative grain overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-1">
            <div className="inline-block bg-ivory rounded-lg p-3 mb-5">
              <img src={LOGO} alt="Cultiva Botanics" className="h-20 w-auto object-contain" />
            </div>
            <p className="font-serif text-2xl leading-tight">Pure Plants.<br />Better Living.</p>
          </div>
          {COL("Explore", [
            { to: "/shop", label: "Products" }, { to: "/our-story", label: "Our Story" },
            { to: "/botanicals", label: "Botanicals" }, { to: "/global-markets", label: "Global Markets" },
            { to: "/journal", label: "Journal" }, { to: "/contact", label: "Contact" },
          ])}
          {COL("Business", [
            { to: "/international-buyers", label: "International Buyers" }, { to: "/partner", label: "Partner With Us" },
            { to: "/export-enquiry", label: "Export Enquiry" }, { to: "/wholesale", label: "Wholesale Enquiry" },
            { to: "/become-a-distributor", label: "Become a Distributor" }, { to: "/quality", label: "Quality & Documentation" },
          ])}
          {COL("Legal", [
            { to: "/legal/privacy", label: "Privacy Policy" }, { to: "/legal/terms", label: "Terms" },
            { to: "/legal/shipping", label: "Shipping" }, { to: "/legal/refund", label: "Refund / Cancellation" },
            { to: "/legal/disclaimer", label: "Disclaimer" },
          ])}
          <div>
            <div className="overline mb-5 text-ivory/50">Company</div>
            <p className="text-sm text-ivory/75 leading-relaxed">
              CULTIVA BOTANICS PRIVATE LIMITED<br />
              CIN: U47912MR2026PTC478754<br />
              Maharashtra, India
            </p>
            <p className="text-sm text-ivory/75 mt-4">
              <a href="mailto:support@cultivabotanics.com" className="hover:text-ivory">support@cultivabotanics.com</a><br />
              <a href="tel:+919623299614" className="hover:text-ivory">+91 96232 99614</a>
            </p>
          </div>
        </div>
        <div className="border-t border-ivory/15 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-ivory/50">
          <p>© {new Date().getFullYear()} Cultiva Botanics Private Limited. India-Origin. Global Vision.</p>
          <p>Building international partnerships in botanical wellness & superfoods.</p>
        </div>
      </div>
    </footer>
  );
}
